export default "__VITE_ASSET__FAZO1dtD__"